interface GMBEmptyStateProps {
  title?: string;
  message?: string;
  icon?: string;
  action?: React.ReactNode;
}

export default function GMBEmptyState({
  title = 'No data yet',
  message = 'There is no data to display for this section yet.',
  icon = 'ri-inbox-line',
  action,
}: GMBEmptyStateProps) {
  return (
    <div className="bg-white dark:bg-gray-800 border border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-10 text-center">
      <i className={`${icon} text-3xl text-gray-300 dark:text-gray-600 mb-3 block`}></i>
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">{title}</h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-sm mx-auto">{message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}